import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a2ad9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "skin-slot-e",
  skin: "e"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", {
      ref: "bgRef",
      class: "bg",
      style: _normalizeStyle(_ctx.phoneStyle)
    }, null, 4)
  ]))
}